import type {
  WorkflowPipelineItem,
  WorkflowPipelineStage,
  WorkflowPipelineView,
} from "@crewfsm/contracts";

export const WORKFLOW_LABELS: Record<WorkflowPipelineStage, string> = {
  NEW_REQUEST: "New requests",
  CONTACTED: "Contacted",
  ESTIMATE_NEEDED: "Prepare estimate",
  AWAITING_CUSTOMER: "Awaiting approval",
  APPROVED: "Approved",
  READY_TO_SCHEDULE: "Unscheduled",
  SCHEDULED: "Scheduled",
  IN_PROGRESS: "In progress",
  TO_INVOICE: "To invoice",
  AWAITING_PAYMENT: "Awaiting payment",
  PAID: "Completed & paid",
  ON_HOLD: "On hold",
  CLOSED: "Closed",
};
export const WORKFLOW_VIEWS: Record<WorkflowPipelineView, string> = {
  ACTIVE: "Active work",
  ALL: "Full workflow",
  LEADS: "Leads",
  SALES: "Sales",
  OPERATIONS: "Field work",
  BILLING: "Billing",
  CLOSED: "Completed & closed",
};
export const PAYMENT_LABELS: Record<
  WorkflowPipelineItem["paymentStatus"],
  string
> = {
  NOT_INVOICED: "Not invoiced",
  DRAFT: "Draft invoice",
  UNPAID: "Unpaid",
  PARTIALLY_PAID: "Partially paid",
  PAID: "Paid",
  PAST_DUE: "Past due",
  VOID: "Invoice voided",
};
const OWNER_ROLE_LABELS = {
  OFFICE_OWNER: "Office owner",
  TECHNICIAN: "Technician",
  ESTIMATE_ASSIGNEE: "Estimate assignee",
  LEAD_ASSIGNEE: "Lead assignee",
} as const;

export function ownerLabel(item: WorkflowPipelineItem): string {
  if (item.officeOwnerName) return `Office owner: ${item.officeOwnerName}`;
  if (item.ownerRole) {
    return `${OWNER_ROLE_LABELS[item.ownerRole]}: ${item.ownerName ?? "Unassigned"}`;
  }
  // Older v1 responses do not identify which assignment supplied the name.
  return item.ownerName ? `Assigned: ${item.ownerName}` : "No assignee";
}

export function money(amount: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: amount % 100 ? 2 : 0,
  }).format(amount / 100);
}
export function displayDate(value: string, timezone: string): string {
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZone: timezone,
  }).format(new Date(value));
}
export function ageLabel(value: string, now = Date.now()): string {
  const days = Math.max(
    0,
    Math.floor((now - new Date(value).getTime()) / 86400000),
  );
  return days === 0 ? "Updated today" : `Updated ${days}d ago`;
}
